import { render, staticRenderFns } from "./angleControl.vue?vue&type=template&id=c8d6e58a&scoped=true&"
import script from "./angleControl.vue?vue&type=script&lang=js&"
export * from "./angleControl.vue?vue&type=script&lang=js&"
import style0 from "./angleControl.vue?vue&type=style&index=0&id=c8d6e58a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8d6e58a",
  null
  
)

export default component.exports